import { FeedLabelStatus } from "../../app.enums";
import { FeedObjectModel } from "../../models/feed-object.model";
import { MilkBottleModel } from "../../models/milk.model";

const getCreatedMilkBottles = (milkBottles: MilkBottleModel[]) =>
	milkBottles.filter(
		(milkBottle) => milkBottle.labelStatus === FeedLabelStatus.New
	);

/**
 * Only New Labels, hide button (Print All will be the only option)
 * Mix of New and updated, it says “Print new”
 */
export const isPrintable = (feedObjectModel: FeedObjectModel[]): boolean => {
	const labels = feedObjectModel
		.map((x) => x.labelStatus)
		.filter((id, index, arr) => arr.indexOf(id) === index); // dedupe

	return (
		labels.includes(FeedLabelStatus.New) &&
		labels.includes(FeedLabelStatus.Updated)
	);
};

export const getPrintDataByMode = (params: {
	mode: string;
	milkBottles: MilkBottleModel[];
}): {
	milkBottles: MilkBottleModel[];
} => {
	switch (params.mode) {
		case "all":
			return {
				milkBottles: params.milkBottles,
			};
		case "created":
			return {
				milkBottles: getCreatedMilkBottles(params.milkBottles),
			};
		default:
			console.error(`Print mode ${params.mode} was unrecognized.`);
			return undefined;
	}
};
